import { Button, Divider } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const ViewMetaDetails = ({ data }) => {

    const Navigate = useNavigate();

    return (
        <div>
            <div className="flex flex-col justify-center w-full p-8 pt-0">
                <div className="mt-2 bg-white shadow-lg">
                    <div className="p-2 border-gray-300 rounded-md ">
                        <div className='mb-2 text-3xl font-bold text-center text-blue-500 underline'>Meta Details</div>
                        <div className='flex justify-center w-full gap-4 mb-6'>
                            <div className='flex flex-col items-center gap-1'>  <img src={data?.og_image} alt='imagegvb' className='border shadow-md h-60 w-96' /><span className='font-semibold'>OG Image</span></div>
                            <div className='flex flex-col items-center gap-1'> <img src={data?.twitter_image} alt='imagytue' className='border shadow-md h-60 w-96' /> <span className='font-semibold'>Twitter Image</span></div>
                        </div>
                        <div className="grid grid-cols-3 gap-5 mt-1">

                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Meta_title</p>
                                    <input
                                        id="meta_title"
                                        placeholder="Enter title"
                                        value={data?.meta_title}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Meta_tag"</p>
                                    <input
                                        id="meta_tag"
                                        placeholder="Enter title"
                                        value={data?.meta_tag}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"


                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">meta_keyword</p>
                                    <input
                                        id="keyword"
                                        value={data?.keyword}
                                        placeholder=''
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Meta_Description</p>
                                    <input
                                        id="meta_description"
                                        value={data?.meta_description}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">canonical</p>
                                    <input
                                        id="canonical"
                                        value={data?.canonical}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Og_Title</p>
                                    <input
                                        id="og_title"
                                        value={data?.og_title}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>

                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Og_Discription</p>
                                    <input
                                        id="og_discription"
                                        placeholder="Enter title"
                                        value={data?.og_discription}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"


                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Og Type</p>
                                    <input
                                        id="og_type"
                                        value={data?.og_type}
                                        placeholder=''
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Og Sitename</p>
                                    <input
                                        id="og_sitename"
                                        value={data?.og_sitename}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold"> og_url</p>
                                    <input
                                        id="og_url"
                                        value={data?.og_url}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">twitter_card</p>
                                    <input
                                        id="twitter_card"
                                        value={data?.twitter_card}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">twitter_description</p>
                                    <input
                                        id="twitter_description"
                                        value={data?.twitter_description}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>

                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Alternate</p>
                                    <input
                                        id="alternate"
                                        value={data?.alternate}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">Robots</p>
                                    <input
                                        id="robots_txt"
                                        value={data?.robots_txt}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>
                            <div className="w-full pl-3 ">
                                <div>
                                    <p className="p-1 text-sm font-semibold">schema</p>
                                    <input
                                        id="schema"
                                        value={data?.schema}
                                        className="w-full p-2 px-4 m-1 border border-gray-300 rounded"

                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="flex justify-center w-full p-3 mt-1 mb-5 m">
                        <Button type="submit" color='secondary' onClick={() => Navigate(`/metadetails/${data?.page_title}`)} variant="contained" className='w-[50%] !font-bold'>
                            Okey
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ViewMetaDetails